/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Not_FoundInputs */

const th_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบรายการนี้ หรือคุณไม่มีสิทธิ์เข้าถึง`)
};

const en_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That does not exist, or you cannot see it.`)
};

const ja_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存在しないか、閲覧する権限がありません。`)
};

const zh_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不存在，或者你无权查看。`)
};

const es_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eso no existe, o no puedes verlo.`)
};

const pt_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso não existe, ou você não pode ver.`)
};

const id_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itu tidak ada, atau Anda tidak bisa melihatnya.`)
};

const fr_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela n’existe pas, ou vous ne pouvez pas le voir.`)
};

const tl_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala iyon, o hindi mo ito makikita.`)
};

const vi_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có thứ đó, hoặc bạn không thấy được nó.`)
};

const ko_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 것은 없거나, 볼 수 없습니다.`)
};

const de_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das gibt es nicht, oder du kannst es nicht sehen.`)
};

const ru_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого нет, либо вы не можете это видеть.`)
};

const tr_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir şey yok ya da göremiyorsunuz.`)
};

const it_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non esiste, oppure non puoi vederlo.`)
};

const pl_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To nie istnieje albo nie możesz tego zobaczyć.`)
};

const uk_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого немає, або ви цього не бачите.`)
};

const hi_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह मौजूद नहीं है, या आप उसे नहीं देख सकते।`)
};

const ar_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير موجود، أو لا يمكنك رؤيته.`)
};

const ms_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ia tidak wujud, atau anda tidak boleh melihatnya.`)
};

const bn_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেটি নেই, অথবা আপনি দেখতে পারবেন না।`)
};

const zh_tw2_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不存在，或你無權查看。`)
};

const zh_hk2_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不存在，或你無權查看。`)
};

const ur_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ موجود نہیں، یا آپ اسے نہیں دیکھ سکتے۔`)
};

const fa_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وجود ندارد، یا شما نمی‌توانید ببینیدش.`)
};

const sw_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haipo, au huwezi kuiona.`)
};

const nl_err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat bestaat niet, of je kunt het niet zien.`)
};

/**
* | output |
* | --- |
* | "That does not exist, or you cannot see it." |
*
* @param {Err_Not_FoundInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_not_found = /** @type {((inputs?: Err_Not_FoundInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_FoundInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_not_found(inputs)
	if (locale === "ja") return ja_err_not_found(inputs)
	if (locale === "zh") return zh_err_not_found(inputs)
	if (locale === "es") return es_err_not_found(inputs)
	if (locale === "pt") return pt_err_not_found(inputs)
	if (locale === "id") return id_err_not_found(inputs)
	if (locale === "fr") return fr_err_not_found(inputs)
	if (locale === "tl") return tl_err_not_found(inputs)
	if (locale === "vi") return vi_err_not_found(inputs)
	if (locale === "ko") return ko_err_not_found(inputs)
	if (locale === "de") return de_err_not_found(inputs)
	if (locale === "ru") return ru_err_not_found(inputs)
	if (locale === "tr") return tr_err_not_found(inputs)
	if (locale === "it") return it_err_not_found(inputs)
	if (locale === "pl") return pl_err_not_found(inputs)
	if (locale === "uk") return uk_err_not_found(inputs)
	if (locale === "hi") return hi_err_not_found(inputs)
	if (locale === "ar") return ar_err_not_found(inputs)
	if (locale === "ms") return ms_err_not_found(inputs)
	if (locale === "bn") return bn_err_not_found(inputs)
	if (locale === "zh-TW") return zh_tw2_err_not_found(inputs)
	if (locale === "zh-HK") return zh_hk2_err_not_found(inputs)
	if (locale === "ur") return ur_err_not_found(inputs)
	if (locale === "fa") return fa_err_not_found(inputs)
	if (locale === "sw") return sw_err_not_found(inputs)
	if (locale === "nl") return nl_err_not_found(inputs)
	return en_err_not_found(inputs)
});